import React, { Component } from 'react'
import { connect } from 'react-redux';
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom';
import { Row, Col } from 'reactstrap';
import Icon from "../../UI/Icon";
import InfoValueCard from '../../shared/InfoValueCard';
import _ from 'lodash';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faFileAlt, faBook, faList, faBriefcase, faFolder } from '@fortawesome/free-solid-svg-icons';
import { getData, getEndosos } from '../../../redux-store/actions';
import Select from 'react-select';
import { get ,put } from '../../../helpers/requests';

import {
  POL_GET_MONEDAS,
  POL_GET_PRODUCTOS,
  CP_SET_CORREDOR_POLIZAS
} from '../../../redux-store/constants/action-types';
import { API, BACKEND_DF, BASE_URL, FRONT_DF_1, SEARCH_DELAY_MS, SINIESTROS_URL } from '../../../CONST';
import {
  cellDateOperation,
  cellNumOperation,
  cellOperation,
  headerDoubleRowOperation,
  headerOperation
} from '../../../helpers/tables';
import BaseTable from '../../shared/BaseTable';
import FilterSelect from '../../shared/FilterSelect';
import { objectsToOptions } from '../../../helpers/selects';
import DownloadBtn from '../../shared/DownloadBtn';
import { getPolicies } from '../../../redux-store/actions/corredorCredito';
import SiniestrosModal from './SiniestrosModal';

const NO_FILTERED_ID = -1;

const intermediaryAccess = (user) => {
  return !user.is_orsan && user.organization;
};

class CorredorCreditoPolicyList extends Component {
  constructor(props) {
    super(props);
    this.filtering = false;
    this.filterParams = '';
    this.fetchDataWithDebounce = _.debounce(this.fetchData, SEARCH_DELAY_MS);
    this.tableRef = React.createRef();
    this.state = {
      showVigentesOnly: true,
      polizasOptions: [],
      selectedPolizas: [],
      selectedPoliza: null,
      loadingPolizas: false,
      user: props.user,
      libroVentaData: {},
      libroVentaPeriodCount: {},
      selectedMoneda: null,
      vigenciaFilter: { min: '', max: '' },
      siniestrosData: {},
      siniestrosRaw: {},
      showSiniestrosModal: false,
    };
  }

  handlePolizasChange = (selectedOptions) => {
    const polizas = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
    this.setState({ selectedPolizas: polizas }, () => {
      if (this.tableRef.current) {
        this.fetchData(this.tableRef.current.state);
      }
    });
  };

  handlePolizaChange = (selectedOption) => {
    const poliza = selectedOption ? selectedOption.value : null;
    this.setState({ selectedPolizas: poliza ? [poliza] : [] }, () => {
      if (this.tableRef.current) {
        this.fetchData(this.tableRef.current.state);
      }
    });
  };

  onFilteredChange = () => {
    this.filtering = true;
  };

  fetchStrategy = (tableState) => {
    if (this.filtering) {
      return this.fetchDataWithDebounce(tableState);
    }
    return this.fetchData(tableState);
  };

  handleVigentesToggle = () => {
    this.setState(prevState => ({
      showVigentesOnly: !prevState.showVigentesOnly,
    }), () => {
      if (this.tableRef.current) {
        this.fetchData(this.tableRef.current.state);
      }
    });
  };


  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(getData({ url: `${BASE_URL}${API.monedas}/`, type: POL_GET_MONEDAS }));
    dispatch(getData({ url: `${BASE_URL}${API.productos}/?tipo_poliza=credito`, type: POL_GET_PRODUCTOS }));

    if (this.isCorredor()) {
      Promise.all([
        this.loadPolizas(),
        this.loadLibroVentaData(),
        this.loadSiniestrosData(),
      ]);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { corredor: prevCorredor, endosos: prevEndosos } = prevProps;
    const { corredor, endosos } = this.props;
    const { showVigentesOnly: prevShowVigentesOnly, selectedPolizas: prevSelectedPolizas } = prevState;
    const { showVigentesOnly, selectedPolizas } = this.state;

    const corredorChanged = JSON.stringify(prevCorredor) !== JSON.stringify(corredor);
    const vigentesFilterChanged = prevShowVigentesOnly !== showVigentesOnly;
    const polizasChanged = JSON.stringify(prevSelectedPolizas) !== JSON.stringify(selectedPolizas);

    if ((corredorChanged || vigentesFilterChanged || polizasChanged) && this.tableRef.current) {
      this.fetchData(this.tableRef.current.state);
      this.setState({ selectedMoneda: null });
    }

    const endososChanged = prevEndosos?.data !== endosos?.data;

    if (endososChanged || polizasChanged || vigentesFilterChanged) {
      this.loadLibroVentaData();
      this.loadSiniestrosData();
    }

    if (corredorChanged) {
      this.loadPolizas();
      this.loadLibroVentaData();
    }
  }

  isCorredor = () => {
    const { user } = this.state;
    return intermediaryAccess(user);
  };

loadSiniestrosData = async () => {
  const { endosos } = this.props;
  const data = endosos?.data || [];

  if (!data.length) return;

  const polizaMap = {};
  data.forEach(item => {
    if (item.nemotecnico && item.poliza && item.numero_vigencia) {
      if (!polizaMap[item.nemotecnico]) {
        polizaMap[item.nemotecnico] = [];
      }
      const key = `${item.poliza}_${item.numero_vigencia}`;
      if (!polizaMap[item.nemotecnico].some(entry => entry.key === key)) {
        polizaMap[item.nemotecnico].push({
          key,
          vigencia: item.numero_vigencia,
          polizaId: item.poliza,
          nemotecnico: item.nemotecnico
        });
      }
    }
  });


  try {
    const results = await Promise.all(
      Object.entries(polizaMap).map(async ([nemotecnico, items]) => {
        const response = await get(`${BASE_URL}${API.siniestros}/?poliza=${nemotecnico}&estado=PAGADO`);
        const siniestros = response.results || [];
        

        const statsByKey = {};
        const rawByKey = {};

        siniestros.forEach(s => {
          const monto = parseFloat(s.monto_pagado || 0);
          
          if (s.vigencias && Array.isArray(s.vigencias) && s.vigencias.length > 0) {
            s.vigencias.forEach(vigencia => {
              const matchingItem = items.find(item => item.vigencia === vigencia);
              if (matchingItem) {
                const { key } = matchingItem;
                if (!statsByKey[key]) {
                  statsByKey[key] = { count: 0, monto: 0 };
                }
                if (!rawByKey[key]) {
                  rawByKey[key] = [];
                }
                statsByKey[key].count += 1;
                statsByKey[key].monto += monto;
                if (!rawByKey[key].some(existing => existing.id === s.id)) {
                  rawByKey[key].push(s);
                }
              }
            });
          }
        });
        
        return { statsByKey, rawByKey };
      })
    );

    const siniestrosData = {};
    const siniestrosRaw = {};

    results.forEach(({ statsByKey, rawByKey }) => {
      Object.entries(statsByKey).forEach(([key, { count, monto }]) => {
        if (!siniestrosData[key]) {
          siniestrosData[key] = { count: 0, monto: 0 };
        }
        siniestrosData[key].count += count;
        siniestrosData[key].monto += monto;
      });

      Object.entries(rawByKey).forEach(([key, arr]) => {
        if (!siniestrosRaw[key]) {
          siniestrosRaw[key] = [];
        }
        arr.forEach(s => {
          if (!siniestrosRaw[key].some(existing => existing.id === s.id)) {
            siniestrosRaw[key].push(s);
          }
        });
      });
    });

    this.setState({ siniestrosData, siniestrosRaw });
  } catch (error) {
    console.error('Error fetching siniestros data:', error);
  }
};


  getSiniestrosForActiveMoneda = (activeMoneda) => {
    const { endosos } = this.props;
    const { selectedPolizas, showVigentesOnly, siniestrosRaw } = this.state;
    let filteredData = endosos.data || [];
  
    if (selectedPolizas && selectedPolizas.length > 0) {
      const polizaIds = new Set(selectedPolizas.map(p => p.id));
      filteredData = filteredData.filter(item => polizaIds.has(item.poliza));
    }
    
    if (showVigentesOnly) {
      const today = moment().format('YYYY-MM-DD');
      filteredData = filteredData.filter(item =>
        item.termino_vigencia && item.termino_vigencia > today
      );
    }
  
    filteredData = filteredData.filter(item => (item.moneda || 'UF') === activeMoneda);
  
    const seen = new Set();
    const collected = [];
    filteredData.forEach(item => {
      const key = `${item.poliza}_${item.numero_vigencia}`;
      (siniestrosRaw[key] || []).forEach(s => {
        if (!seen.has(s.id)) {
          seen.add(s.id);
          collected.push(s);
        }
      });
    });
    return collected;
  };


  loadPolizas = async () => {
    const { user } = this.state;
    const { dispatch } = this.props;
    try {
      this.setState({ loadingPolizas: true });
      const url = `${BASE_URL}${API.creditosIntermediarios}/polizas/?corredor_id=${user.organization}`;
      const polizas = await get(url);

      const options = polizas.map((poliza) => ({
        label: `${poliza.nemotecnico} - ${poliza.asegurado_nombre || 'Sin cliente'}`,
        value: { 
          id: poliza.poliza_id, 
          nemotecnico: poliza.nemotecnico,
          asegurado_nombre: poliza.asegurado_nombre,
        },
      }));

      this.setState({ polizasOptions: options });
      dispatch({ type: CP_SET_CORREDOR_POLIZAS, payload: options });
    } catch (error) {
      console.error('Error al cargar las pólizas:', error);
    } finally {
      this.setState({ loadingPolizas: false });
    }
  };


  calculateGeneralInfo = () => {
    const { endosos } = this.props;
    const { selectedPolizas, showVigentesOnly, libroVentaData, libroVentaPeriodCount, siniestrosData } = this.state;

    let filteredData = endosos.data || [];

    if (selectedPolizas && selectedPolizas.length > 0) {
      const polizaIds = new Set(selectedPolizas.map(p => p.id));
      filteredData = filteredData.filter(item => polizaIds.has(item.poliza));
    }
    if (showVigentesOnly) {
      const today = moment().format('YYYY-MM-DD');
      filteredData = filteredData.filter(item =>
        item.termino_vigencia && item.termino_vigencia > today
      );
    }

    if (!filteredData || filteredData.length === 0) return {};

    const validKeys = new Set(
      filteredData.map(item => `${item.poliza}_${item.numero_vigencia}`)
    );

    const statsByMoneda = {};

    filteredData.forEach(item => {
      const moneda = item.moneda || 'UF';

      if (!statsByMoneda[moneda]) {
        statsByMoneda[moneda] = { prima_real: 0, prima_minima: 0, prima_minima_anual: 0, siniestralidad_count: 0, siniestralidad_monto: 0, comision_generada: 0 };
      }
      statsByMoneda[moneda].prima_minima_anual += parseFloat(item.prima_minima_anual_amt || 0);

      const key = `${item.poliza}_${item.numero_vigencia}`;
      const primaReal = validKeys.has(key) ? (libroVentaData[key] || 0) : 0;
      statsByMoneda[moneda].prima_real += primaReal;
      const siniestroStats = siniestrosData[key] || { count: 0, monto: 0 };
      statsByMoneda[moneda].siniestralidad_count += siniestroStats.count;
      statsByMoneda[moneda].siniestralidad_monto += siniestroStats.monto;

      // Hay un tema con la prima_neta_generada_mo, donde muchas veces será NULL o 0 para periodos no subidos, por eso algunos calculos mueren.
      // Por mientras lo dejaré como ANUAL como backup en caso de que no tengan nada subido.
      // Otra opcion podría ser que se cuenten nomás como periodos hábiles los que aparezcan, eso sería quitar el check de nulidad (línea 385)
      const periodsWithData = libroVentaPeriodCount[key] || 0;
      const primaMinimaMensual = parseFloat(item.prima_minima_anual_amt || 0) / 12;
      const primaMinima = periodsWithData > 0
        ? primaMinimaMensual * periodsWithData
        : parseFloat(item.prima_minima_anual_amt || 0); // anual as fallback
      statsByMoneda[moneda].prima_minima += primaMinima;

      const comisionPct = parseFloat(item.comision_pct || 0);
      statsByMoneda[moneda].comision_generada += (primaReal * comisionPct) / 100;
    });

    Object.values(statsByMoneda).forEach(stats => {
      const denominator = Math.max(stats.prima_real, stats.prima_minima);
      stats.siniestralidad_porcentaje = denominator > 0
        ? (stats.siniestralidad_monto / denominator) * 100
        : 0;
    });

    return statsByMoneda;
  };
  
  fetchLibroVentaData = async (polizaId, numeroVigencia) => {
    try {
      const url = `${BASE_URL}${API.librosVenta}/?poliza_id=${polizaId}&vigencia=${numeroVigencia}&page_size=100`;
      const response = await get(url);
      return response.results || response.data || [];
    } catch (error) {
      console.error('Error fetching LibroVenta data:', error);
      return [];
    }
  };
  
  getPrimaRealFromLibroVenta = (polizaId, numeroVigencia) => {
    const { libroVentaData } = this.state;
    return libroVentaData?.[`${polizaId}_${numeroVigencia}`] || 0;
  };
  

  handleAseguradoClick = (item) => {
    const { polizasOptions } = this.state;
    const match = polizasOptions.find(opt => opt.value.id === item.poliza);
    if (!match) return;

    this.setState({
      selectedPoliza: match.value,
      showVigentesOnly: false,
    }, () => {
      if (this.tableRef.current) {
        this.fetchData(this.tableRef.current.state);
      }
    });
  };
  
  loadLibroVentaData = async () => {
    const { user } = this.state;
    const { corredor } = this.props;

    const corredor_id = user.is_orsan ? corredor?.id : user.organization;
    if (!corredor_id) return;

    try {
      const url = `${BASE_URL}${API.librosVenta}/by_corredor/?corredor_id=${corredor_id}`;
      const rows = await get(url);

      const libroVentaData = {};
      const libroVentaPeriodCount = {};

      rows.forEach(row => {
        const key = `${row.poliza_id}_${row.vigencia}`;
        if (!libroVentaData[key]) {
          libroVentaData[key] = 0;
          libroVentaPeriodCount[key] = 0;
        }
        libroVentaData[key] += (row.prima_neta_generada_mo || 0);
        if (row.prima_neta_generada_mo !== null && row.prima_neta_generada_mo !== undefined) {
          libroVentaPeriodCount[key] += 1;
        }
      });

      this.setState({ libroVentaData, libroVentaPeriodCount });
    } catch (error) {
      console.error('Error fetching libro venta data:', error);
    }
  };

  redirectWithTokenAndNemotecnico = (nemotecnico) => (event) => {
    event.preventDefault();
    const { loginIdToken } = this.props;

    const url = `${SINIESTROS_URL}denuncia-credito?nemotecnico=${nemotecnico}`;

    const options = {
      method: 'GET',
      headers: {
        'X-JWT-TOKEN': loginIdToken,
      },
      credentials: 'include',
    };

    fetch(url, options)
      .then((response) => {
        if (response.ok) {
          window.location.href = url;
        }
      })
      .catch(() => {});
  };

  fetchData = (state) => {
    const { dispatch, user } = this.props;
    const { selectedPolizas, showVigentesOnly } = this.state;
    this.filtering = false;

    let filterParams = `page=${state.page + 1}&`;

    if (user.is_orsan) {
      const { corredor } = this.props;
      if (corredor) {
        filterParams = `${filterParams}corredor_id=${corredor.id}&`;
      }
    } else if (user.organization) {
      filterParams = `${filterParams}corredor_id=${user.organization}&`;
    }

    if (selectedPolizas && selectedPolizas.length > 0) {
      const polizaIds = selectedPolizas.map(p => p.id).join(',');
      filterParams = `${filterParams}poliza__in=${polizaIds}&`;
    }

    if (showVigentesOnly) {
      const today = moment().format('YYYY-MM-DD');
      filterParams = `${filterParams}termino_vigencia__gt=${today}&`;
    }

    if (state.filtered.length) {
      state.filtered.forEach((node) => {
        let validFilter = false;
        let filterValue = node.value;

        if (node.id === 'numero_vigencia') {
          const [min, max] = node.value.split(':');
          if (min && !isNaN(min)) {
            filterParams = `${filterParams}numero_vigencia__gte=${min}&`;
          }
          if (max && !isNaN(max)) {
            filterParams = `${filterParams}numero_vigencia__lte=${max}&`;
          }
          return;
        }
        if (typeof node.value === 'number' && node.value > 0) {
          validFilter = true;
        } else if (typeof node.value === 'string' && node.value.length > 2 && node.value !== 'all-options') {
          validFilter = true;

          const dateFields = [
            'balance__inicio_vigencia', 
            'balance__termino_vigencia',
            'inicio_vigencia',
            'termino_vigencia',
            'termino_vigencia__gt',
            'termino_vigencia__lt',
          ];
          if (dateFields.includes(node.id)) {
            const date = moment(filterValue, FRONT_DF_1, true);
            if (date.isValid()) {
              filterValue = date.format(BACKEND_DF);
            } else {
              validFilter = false;
            }
          }
        }
        if (validFilter) {
          filterParams = `${filterParams}${node.id}=${filterValue}&`;
        }
      });
    }


    // only fetch data if filters have changed
    if (filterParams !== this.filterParams) {
      this.filterParams = filterParams;
      dispatch(getEndosos(filterParams));
    }
  };

  render() {
    const {
      dispatch, loading, endosos,
      poliza: { monedas, productos },
      xlsxUrl, pdfUrl,
      login,
    } = this.props;

    const {
      showVigentesOnly,
      polizasOptions,
      selectedPoliza,
      selectedPolizas,
      loadingPolizas,
      user,
    } = this.state;

    const isCorredor = this.isCorredor();
    const { showSiniestrosModal } = this.state;

    const accionesPermitidas = login?.user?.acciones_permitidas?.acciones || [];
    const libroVentaAllowedNemotecnicos = new Set(
      accionesPermitidas
        .filter(a => a.accion.slug === 'ver-modulo-libro-venta' && a.applies && a.is_active)
        .map(a => a.policy_nemotecnico)
    );

    if (monedas.length === 0) {
      return null;
    }

    const monedasOptions = objectsToOptions(monedas, 'nombre_corto', true);
    const productosOptions = objectsToOptions(productos, 'descripcion', true);
    const generalInfoByMoneda = this.calculateGeneralInfo();
    const monedasInfo = Object.keys(generalInfoByMoneda);
    const { selectedMoneda } = this.state;

    let activeMoneda = selectedMoneda;

    if (!activeMoneda) {
      activeMoneda = monedasInfo.includes('UF')
        ? 'UF'
        : monedasInfo[0];
    }
    const generalInfo = generalInfoByMoneda[activeMoneda] || { prima_real: 0, prima_minima: 0, siniestralidad: 0, comision_generada: 0 };

    let tableData = endosos.data || [];
    
    if (selectedPolizas && selectedPolizas.length > 0) {
      const polizaIds = new Set(selectedPolizas.map(p => p.id));
      tableData = tableData.filter(item => polizaIds.has(item.poliza));
    }
    
    if (showVigentesOnly) {
      const today = moment().format('YYYY-MM-DD');
      tableData = tableData.filter(item => 
        item.termino_vigencia && item.termino_vigencia > today
      );
    }

    const columns = [
      {
        Header: headerOperation('Código'),
        id: 'poliza__base__nemotecnico__icontains',
        accessor: i => cellOperation(i.nemotecnico),
        minWidth: 110,
        sortable: false,
      },
      {
        Header: headerOperation('Vigencia'),
        id: 'numero_vigencia',
        accessor: i => cellOperation(i.numero_vigencia),
        minWidth: 80,
        sortable: false,
        filterMethod: () => true,
        Filter: ({ onChange }) => (
          <div style={{ display: 'flex', gap: '4px' }}>
            <input
              type="number"
              placeholder="Min"
              value={this.state.vigenciaFilter.min}
              min={1}
              style={{ width: '48%' }}
              className="no-spinner"
              onChange={e => {
                const min = e.target.value;
                this.setState(prev => ({ vigenciaFilter: { ...prev.vigenciaFilter, min } }));
                onChange(`${min}:${this.state.vigenciaFilter.max}`);
              }}
            />
            <input
              type="number"
              placeholder="Max"
              value={this.state.vigenciaFilter.max}
              min={1}
              style={{ width: '48%' }}
              className="no-spinner"
              onChange={e => {
                const max = e.target.value;
                this.setState(prev => ({ vigenciaFilter: { ...prev.vigenciaFilter, max } }));
                onChange(`${this.state.vigenciaFilter.min}:${max}`);
              }}
            />
          </div>
        ),
      },
      {
        Header: headerOperation('Asegurado'),
        id: 'asegurado__nombre__icontains',
        accessor: i => (
          <div className="table-cell">
            <span
              className="table-link policy"
              style={{ cursor: 'pointer' }}
              onClick={() => this.handleAseguradoClick(i)}
            >
              {i.asegurado?.nombre}
            </span>
          </div>
        ),
        minWidth: 140,
        sortable: false,
      },
      {
        Header: headerOperation('Producto'),
        id: 'poliza__base__tipo_cobertura_id',
        accessor: i => cellOperation(i.cobertura),
        Filter: obj => (
          <FilterSelect
            onFilterChange={obj.onChange}
            filter={obj.filter}
            options={productosOptions}
            defaultOption={{ label: 'Todos', value: NO_FILTERED_ID }}
          />
        ),
        sortable: false,
        minWidth: 150,
      },
      {
        Header: headerDoubleRowOperation('Inicio', 'Vigencia'),
        id: 'inicio_vigencia',
        accessor: i => cellDateOperation(i.inicio_vigencia),
        sortable: false,
        minWidth: 95,
      },
      {
        Header: headerDoubleRowOperation('Término', 'Vigencia'),
        id: 'termino_vigencia',
        accessor: i => cellDateOperation(i.termino_vigencia),
        sortable: false,
        minWidth: 95,
      },
      {
        Header: headerOperation('Moneda'),
        id: 'base__moneda_asegurada_id',
        accessor: i => cellOperation(i.moneda),
        Filter: obj => (
          <FilterSelect
            onFilterChange={obj.onChange}
            filter={obj.filter}
            options={monedasOptions}
            defaultOption={{ label: 'Todas', value: NO_FILTERED_ID }}
          />
        ),
        sortable: false,
        minWidth: 90,
      },
      {
        Header: headerDoubleRowOperation('Monto', 'Considerado'),
        id: 'monto_considerado',
        accessor: i => cellNumOperation(i.monto_asegurado_estimado_amt, 'float'),
        minWidth: 120,
        filterable: false,
        sortable: false,
      },
      {
        Header: headerDoubleRowOperation('Prima', 'Mínima Anual'),
        id: 'prima',
        accessor: i => cellNumOperation(i.prima_minima_anual_amt, 'float'),
        minWidth: 120,
        filterable: false,
        sortable: false,
      },
      {
        Header: headerOperation('Estado'),
        id: 'estado',
        accessor: i => {
          const today = moment().format('YYYY-MM-DD');
          const isVigente = i.termino_vigencia && i.termino_vigencia > today;
          return cellOperation(isVigente ? 'Vigente' : 'No Vigente');
        },
        minWidth: 100,
        filterable: false,
        sortable: false,
      },
      {
        Header: headerOperation('% Comisión'),
        id: 'comision_pct',
        accessor: i => cellNumOperation(i.comision_pct, 'float'),
        minWidth: 70,
        filterable: false,
        sortable: false,
      },
      {
        Header: headerOperation('Acciones'),
        id: 'actions',
        accessor: i => (
          <div
            className="table-cell"
            style={{ textAlign: 'center' }}
          >
            <span title="Ver Detalle">
              <Link
                to={{
                  pathname: `/corredor/polizas-credito/${i.poliza}`,
                  state: { vigencia: i.numero_vigencia }
                }}
                className="table-link policy"
              >
                <FontAwesomeIcon icon={faEye} />
              </Link>
            </span>
            &nbsp;&nbsp;
            <span title="Ver Prórrogas">
              <Link
                to={{
                  pathname:`/prorroga/solicitud-prorroga/${i.poliza}`,
                  state: { vigencia: i.numero_vigencia }
                }}
                className="table-link"
              >
                <FontAwesomeIcon icon={faFileAlt} />
              </Link>
            </span>
            &nbsp;&nbsp;
            {libroVentaAllowedNemotecnicos.has(i.nemotecnico) && (
              <span title="Ver Libro de Ventas">
                <Link
                  to={{
                    pathname:`/corredor/libros-venta/${i.poliza}`,
                    state: { vigencia: i.numero_vigencia }
                  }}
                  className="table-link"
                >
                  <FontAwesomeIcon icon={faBook} />
                </Link>
              </span>
            )}
            &nbsp;&nbsp;
            <span title="Ver Líneas de Crédito">
              <Link
                to={{
                  pathname: `/asegurado/lineas-credito/${i.poliza}`,
                  state: { returnTo: '/corredor/polizas-credito',
                           client: i.asegurado, }
                }}
                className="table-link"
              >
                <FontAwesomeIcon icon={faBriefcase} />
              </Link>
            </span>
            &nbsp;&nbsp;
            <span title="Ver Siniestros">
              <a            
                href={`${SINIESTROS_URL}denuncia-credito?nemotecnico=${i.nemotecnico}`}
                className="table-link"
                onClick={this.redirectWithTokenAndNemotecnico(i.nemotecnico)}
              >
                <FontAwesomeIcon icon={faFolder} />
              </a>
            </span>
          </div>
        ),
        filterable: false,
        sortable: false,
        minWidth: 130,
      },
    ];

    return (
      <>
        <div style={{ padding: '0 0 16px 16px' }}>
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: '450px auto',
            gridGap: '16px',
            alignItems: 'start'
          }}>
            {/* Left side - Policy selector and filters */}
            <div>
              {/* Policy Selector for Corredor */}
              {isCorredor && (
                <div style={{ marginBottom: '16px' }}>
                  <label className="orsan-label" style={{ marginBottom: '8px', display: 'block' }}>
                    Pólizas
                  </label>
                  <Select
                    id="poliza-select"
                    name="poliza-select"
                    className="orsan-form-element"
                    isMulti={true}
                    value={selectedPolizas ? selectedPolizas.map(p => ({ 
                      label: `${p.nemotecnico} - ${p.asegurado_nombre || 'Sin cliente'}`, 
                      value: p 
                    })) : []}
                    onChange={this.handlePolizasChange}
                    options={polizasOptions}
                    placeholder="Seleccione pólizas"
                    isLoading={loadingPolizas}
                    isDisabled={loadingPolizas}
                    isClearable={true}
                  />
                </div>
              )}
              
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                  <input
                    type="checkbox"
                    checked={showVigentesOnly}
                    onChange={this.handleVigentesToggle}
                    style={{ marginRight: '8px' }}
                  />
                  <span className="orsan-label" style={{ margin: 0 }}>
                    Mostrar solo pólizas vigentes
                  </span>
                </label>
              </div>
            </div>

            {/* Right side - Summary cards */}
            <div>
              {monedasInfo.length > 1 && (
                <div className="d-flex align-items-center ml-2">
                  <div className="d-flex">
                    {monedasInfo.map(m => (
                      <button
                        key={m}
                        onClick={() => this.setState({ selectedMoneda: m })}
                        className={`btn btn-sm mr-1 ${
                          activeMoneda === m ? 'btn-primary' : 'btn-outline-primary'
                        } rounded-pill`}
                      >
                        {m}
                      </button>
                    ))}
                  </div>
                  <Icon
                    id="dashboard-moneda-info"
                    placement="left"
                    tooltipText="Filtra el dashboard según moneda. No se hace conversión — se agrupa según póliza."
                    style={{ display: 'flex', alignItems: 'center' }}
                  >
                    <i
                      className="fas fa-info-circle"
                      style={{
                        color: 'var(--orsan-blue)',
                        cursor: 'pointer'
                      }}
                    />
                  </Icon>
                </div>
              )}
              <Row noGutters style={{ gap: '12px' }} className="align-items-stretch">
                <Col className="d-flex flex-column">
                  <InfoValueCard
                    title="Prima Real"
                    loading={loading}
                    amount={generalInfo.prima_real}
                    moneda={activeMoneda}
                    color="var(--orsan-blue)"
                  />
                </Col>
                <Col className="d-flex flex-column">
                  <InfoValueCard 
                    title="Prima Mínima"
                    loading={loading}
                    amount={generalInfo.prima_minima}
                    secondAmount={generalInfo.prima_minima_anual}
                    secondAmountLabel="Anual"
                    moneda={activeMoneda}
                    color="var(--orsan-green)"
                  />
                </Col>
                <Col className="d-flex flex-column">
                  <InfoValueCard
                    title="Siniestros Pagados"
                    loading={loading}
                    amount={generalInfo.siniestralidad_monto}
                    moneda={activeMoneda}
                    color="var(--orsan-red)"
                  />
                </Col>
                <Col className="d-flex flex-column">
                  <div
                    style={{ cursor: 'pointer', position: 'relative' }}
                    onClick={() => this.setState({ showSiniestrosModal: true })}
                    title="Ver detalle de siniestros"
                  >
                    <InfoValueCard
                      title="Siniestralidad"
                      loading={loading}
                      amount={generalInfo.siniestralidad_porcentaje}
                      showMoneda={false}
                      amountLabel="%"
                      color="var(--orsan-orange)"
                    />
                    <span style={{position: 'absolute',top: 8,right: 10,color: 'var(--orsan-blue)',}}>
                      <FontAwesomeIcon icon={faList} /> Ver detalle
                    </span>
                  </div>
                </Col>
                <Col className="d-flex flex-column">
                  <InfoValueCard
                    title="Comisión Generada"
                    loading={loading}
                    amount={generalInfo.comision_generada}
                    moneda={activeMoneda}
                    color="var(--orsan-blue-s3)"
                  />
                </Col>
              </Row>
            </div>
          </div>
        </div>
            
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr auto auto',
            gridGap: '10px',
            marginBottom: '6px',
          }}
        >
          <div style={{ gridColumnStart: 2 }}>
            <DownloadBtn
              id='xlsx-download'
              text='XLSX'
              tipText='Descargar Planilla Excel'
              url={xlsxUrl}
            />
          </div>
          <div style={{gridColumnStart: 3}}>
            <DownloadBtn
              id='pdf-download'
              text='PDF'
              tipText='Descargar PDF'
              url={pdfUrl}
            />
          </div>
        </div>
        
        <BaseTable
          tableRef={this.tableRef}
          columns={columns}
          data={tableData}
          filterable
          loading={loading}
          onFetchData={this.fetchStrategy}
          onFilteredChange={this.onFilteredChange}
          pages={endosos.pages}
          resultCount={endosos.count}
          showPagination={true}
          style={{ maxHeight: '63vh' }}
        />
        <SiniestrosModal
          isOpen={showSiniestrosModal}
          onClose={() => this.setState({ showSiniestrosModal: false })}
          siniestros={this.getSiniestrosForActiveMoneda(activeMoneda)}
          moneda={activeMoneda}
        />
      </>
    );
  }
}

CorredorCreditoPolicyList.propTypes = {
  dispatch: PropTypes.func.isRequired,
  endosos: PropTypes.shape({
    data: PropTypes.array,
    pages: PropTypes.number,
    count: PropTypes.number,
  }).isRequired,
  xlsxUrl: PropTypes.string.isRequired,
  pdfUrl: PropTypes.string.isRequired,
  poliza: PropTypes.shape({
    monedas: PropTypes.array,
    productos: PropTypes.array,
  }).isRequired,
  user: PropTypes.shape({
    organization_name: PropTypes.string,
    organization_rut: PropTypes.string,
    organization: PropTypes.number,
    is_orsan: PropTypes.bool,
  }).isRequired,
  loading: PropTypes.bool.isRequired,
  corredor: PropTypes.shape({
    id: PropTypes.number,
  }),
  loginIdToken: PropTypes.string,
};

CorredorCreditoPolicyList.defaultProps = {
  corredor: null,
  loginIdToken: '',
};

const mapStateToProps = state => ({
  endosos: state.corredorCredito.list.endosos,
  xlsxUrl: state.corredorCredito.list.xlsxUrl,
  pdfUrl: state.corredorCredito.list.pdfUrl,
  loading: state.corredorCredito.loading,
  poliza: state.poliza,
  user: state.login.user,
  loginIdToken: state.login.id_token,
  login: state.login
});

export default connect(mapStateToProps)(CorredorCreditoPolicyList);